import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import store from '@/store'
import ServerValidationError from '@/helpers/ServerValidationError'
import snack from '@/helpers/snack'

export default {
  GET_SERVICE_CATEGORIES: ({ commit, state }, payload) => {
    if (payload.showPreloader) {
      commit('setLoad', true)
    }
    if (payload.clearOldData) {
      commit('setServiceCategories', [])
    }
    commit('setLoadingWorkPlaceServiceCategories', true)

    const url = payload.fromAllCompanies
      ? Vue.config.modules.crm.api.serviceCategories.all
      : Vue.config.modules.crm.api.serviceCategories.categoriesWithServices.replace('$1', payload.companyId)

    return request(
      'GET',
      `${Vue.config.server}/${url}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setServiceCategories', state.serviceCategories.concat(payload.fromAllCompanies ? data.items : data))
        commit('setServiceCategoryFilters', data.filters)
        if (payload.showPreloader) commit('setLoad', false)
        commit('setLoadingWorkPlaceServiceCategories', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_SERVICE_CATEGORY: ({ commit, state }, serviceCategoryID) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.one.replace('$1', serviceCategoryID)}`,
      {
        params: {
          with: 'services;workplaces',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const serviceCategory = response.data.data
        commit('setServiceCategory', serviceCategory)
        commit('setTitle', serviceCategory.title)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_SERVICE_CATEGORY_WITH_CATEGORIES: ({ commit, state }, serviceCategoryID) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.one.replace('$1', serviceCategoryID)}`,
      {
        params: {
          with: 'services;workplaces',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const serviceCategory = _.cloneDeep(response.data.data)

          commit('setServiceCategory', serviceCategory)
          commit('setTitle', serviceCategory.title)
          // Get categories
          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`,
            {
              params: {
                offset: 0,
                limit: 30,
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          // const items = array.removeByID(data.items, state.serviceCategory.id);
          // TODO Refactoring PG-388
          // @ToDo: Check please. Kostyl v 2.0
          _.forEach(data.items, (i, item) => {
            if (item.id === state.serviceCategory.id) {
              data.items.splice(i, 1)
            }
          })
          commit('setServiceCategories', data.items)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },
  GET_SERVICE_CATEGORY_WITH_WORKPLACES: ({ commit, state }, unitID) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.allWithWorkplaces.replace('$1', unitID)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const serviceCategory = response.data.data
        commit('setServiceWithWorkplaces', serviceCategory)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  UPDATE_SERVICE_CATEGORY: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.one.replace(
        '$1',
        state.serviceCategory.id,
      )}`,
      {
        title: state.serviceCategory.title,
        parent_id: state.serviceCategory.parent_id,
        show_aggregator: Number(state.serviceCategory.show_aggregator) || 0,
        priority: state.serviceCategory.priority,
      },
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('changeServiceCategory', { key: state.serviceCategory.id, value: state.serviceCategory })
          commit('setTitle', state.serviceCategory.title)

          commit('setServiceCategoryErrors', null)
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        commit('setLoad', false)
      },
    )
  },
  CREATE_SERVICE_CATEGORY: ({ commit, dispatch, state }) => {
    commit('setLoad', true)
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`,
      {
        title: state.serviceCategory.title,
        parent_id: state.serviceCategory.parent_id,
        updated_at: state.serviceCategory.updated_at,
        created_at: state.serviceCategory.created_at,
        show_aggregator: Number(state.serviceCategory.show_aggregator) || 0,
        company_id: store.getters.user.company_id,
        priority: state.serviceCategory.priority,
      },
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data

          commit('setServiceCategoryField', { field: 'id', fieldValue: data.id })
          commit('setTitle', state.serviceCategory.title)
          commit('unshiftServiceCategories', { ...state.serviceCategory })

          router.push({ path: Vue.config.modules.crm.route.serviceCategory.one.replace('$1', data.id) })
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        commit('setLoad', false)
      },
    )
  },
  DELETE_SERVICE_CATEGORY: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.one.replace(
        '$1',
        state.serviceCategory.id,
      )}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('deleteServiceCategory', state.serviceCategory.id)
          const categoriesLength = state.serviceCategories.length

          if (categoriesLength != 0) {
            commit('setServiceCategory', state.serviceCategories[0])
            commit('setServiceCategoryField', { field: 'id', fieldValue: state.serviceCategories[0].id })
            commit('setTitle', state.serviceCategories[0].title)

            commit('setServiceCategoryErrors', null)
            commit('setLoad', false)

            router.push({ path: Vue.config.modules.crm.route.serviceCategory.one.replace('$1', 1) })

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.deleteMessage,
            })
          } else {
            router.push({ path: Vue.config.modules.crm.route.services.all })
          }
        } else {
          commit('setServiceCategoryErrors', null)
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(response, 'customerValidation')
        commit('setLoad', false)
      },
    )
  },
  async GET_SERVICE_CATEGORIES_WITH_SERVICES({ state, commit }) {
    try {
      const [serviceCategoriesResponse, servicesResponse] = await Promise.all([
        request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`, {}, true),
        request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`, {}, true),
      ])
      if (serviceCategoriesResponse.data.result === 'success' && servicesResponse.data.result === 'success') {
        const serviceCategories = serviceCategoriesResponse.data.data.items
        const services = servicesResponse.data.data.items
        const result = _.map(serviceCategories, category => {
          category.services = _.map(
            _.filter(services, service => service.service_category_id === category.id),
            service => {
              service.active = false
              return service
            },
          )
          return category
        })
        commit('setServiceCategories', result)
      } else {
        throw new Error(Vue.config.localization.ru.loadingError)
      }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.loadingError)
    }
  },
  async GET_SERVICE_CATEGORIES_WITHOUT_GROUP({ commit, state }, companyId) {
    try {
      const res = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.categoriesWithServices.replace(
          '$1',
          companyId,
        )}`,
        {
          params: {
            with: 'serviceCategory',
            orderBy: 'popular',
            sortedBy: 'desc',
          },
        },
        true,
      )
      commit('filteredGroupService', res.data.data)
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.loadingError)
    }
  },
  async FETCH_SERVICE_CATEGORIES({ commit, state }, payload) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`,
        {
          params: payload,
        },
        true,
      )

      commit('setShortServiceCategories', response.data.data.items)
      return response.data.data.items
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return []
    }
  },
}
